import noop from '@anm/helpers/noop';
import { useRef } from 'react';

import routes from '../../../../routes';

const { Link } = routes;

type CustomizationLinkProps = {
  projectId: string;
  tab?: string;
  dataButton?: string;
  onCanNotOpen?(): void;
};

const useCustomizationTabLink = ({
  projectId,
  dataButton,
  tab = 'embed',
  onCanNotOpen = noop
}: CustomizationLinkProps) => {
  const paramsRef = useRef({ tab, projectId });

  const canNotOpenHandler = (event: React.MouseEvent<Element, MouseEvent>) => {
    event.preventDefault();
    onCanNotOpen();
  };

  const linkProps = { ...(dataButton && { 'data-button': dataButton }) };

  const renderSettingsLink = (children: JSX.Element) =>
    projectId ? ( // TODO: check condition and canNotOpenHandler
      <Link route="video" params={paramsRef.current}>
        <a>{children}</a>
      </Link>
    ) : (
      <a {...linkProps} onClick={canNotOpenHandler}>
        {children}
      </a>
    );

  return renderSettingsLink;
};

export default useCustomizationTabLink;
